// Single source of truth for the Scraye brand colors.
export const SCRAYE_ORANGE = "#E6553F";
export const SCRAYE_ORANGE_RGB = "230, 85, 63"; // same brand colour, for use inside rgba().
export const SCRAYE_ORANGE_HIGHLIGHT = "#b94331";
